import { render, staticRenderFns } from "./owner.vue?vue&type=template&id=24f23e4e&scoped=true&"
import script from "./owner.vue?vue&type=script&lang=js&"
export * from "./owner.vue?vue&type=script&lang=js&"
import style0 from "./owner.vue?vue&type=style&index=0&lang=css&"
import style1 from "./owner.vue?vue&type=style&index=1&id=24f23e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f23e4e",
  null
  
)

export default component.exports